import { Text, View } from '@react-pdf/renderer';
import { dobFormat } from "helpers/common";
import moment from "moment";

export const ClientDetailsPdf = ({ styles, data }) => {
  return (
    <>
      <View>
        <Text style={styles.subHeading}>FIRST NAME</Text>
        <Text style={{ ...styles.fontLight, fontSize: 16, marginTop: "2px" }}>{data?.firstname}</Text>
      </View>
      <View>
        <Text style={styles.subHeading}>LAST NAME</Text>
        <Text style={{ fontSize: 16, ...styles.fontLight, marginTop: "2px" }}>{data?.lastname}</Text>
      </View>
      <View>
        <Text style={styles.subHeading}>GRADE</Text>
        <Text style={{ ...styles.para, ...styles.clientSubInfo, marginTop: 3 }}>{data?.grade}</Text>
      </View>
      <View>
        <Text style={styles.subHeading}>DATE OF BIRTH</Text>
        <Text style={{ ...styles.para, ...styles.clientSubInfo, marginTop: 3 }}>{data?.dob}</Text>
      </View>
      <View>
        <Text style={styles.subHeading}>AGE</Text>
        <Text style={{ ...styles.para, ...styles.clientSubInfo, marginTop: 3 }}>{data?.age}</Text>
      </View>
      <View>
        <Text style={styles.subHeading}>DATE OF INTAKE</Text>
        <Text style={{ ...styles.para, ...styles.clientSubInfo, marginTop: 3 }}>{data?.date_of_intake ? moment(data?.date_of_intake).format(dobFormat) : "--"}</Text>
      </View>
    </>
  )
}